import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Card, Input, Button } from '@getpay93/ui';
import { useAuth } from '../auth/AuthContext';
import { homePathFor } from '../auth/session';

export function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const session = await login(email, password);
      nav(homePathFor(session), { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'No se pudo iniciar sesión');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="gp-light" style={{ minHeight: '100vh', background: 'var(--bg)', display: 'grid', placeItems: 'center', padding: 24 }}>
      <Card style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ textAlign: 'center', marginBottom: 20 }}>
          <span style={{ fontSize: 24, fontWeight: 800, letterSpacing: '-.02em', color: 'var(--text-strong)' }}>Get<span style={{ color: 'var(--brand-green)' }}>Pay</span>93</span>
        </div>
        <form onSubmit={onSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <Input placeholder="Correo" type="email" value={email} onChange={(e) => setEmail(e.currentTarget.value)} autoComplete="email" required />
          <Input placeholder="Contraseña" type="password" value={password} onChange={(e) => setPassword(e.currentTarget.value)} autoComplete="current-password" required />
          {error ? <p style={{ margin: 0, color: 'var(--status-overdue)', fontSize: 13, fontWeight: 600 }}>{error}</p> : null}
          <Button type="submit" fullWidth disabled={busy}>{busy ? 'Entrando…' : 'Entrar'}</Button>
        </form>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16, fontSize: 13 }}>
          <Link to="/recuperar">¿Olvidaste tu contraseña?</Link>
          <Link to="/registro">Crear cuenta</Link>
        </div>
        <p style={{ textAlign: 'center', marginTop: 12, marginBottom: 0, fontSize: 13, color: 'var(--text-hint)' }}>
          ¿Eres cliente de un negocio? <Link to="/registro?tipo=cliente">Regístrate como cliente</Link>
        </p>
      </Card>
    </div>
  );
}
